

























































import { defineComponent, PropType } from '@vue/composition-api';
import OareDialog from '@/components/base/OareDialog.vue';
import { ErrorsRowWithUser, ErrorStatus } from '@oare/types';
import sl from '@/serviceLocator';
import { formatTimestamp, resetAdminBadge } from '@/utils';

export default defineComponent({
  name: 'ErrorLogDialog',
  components: {
    OareDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object as PropType<ErrorsRowWithUser>,
      required: true,
    },
  },
  setup({ error }, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const statusItems: ErrorStatus[] = ['New', 'In Progress', 'Resolved'];

    const updateStatus = async (status: ErrorStatus) => {
      try {
        emit('update-status', status);
        await server.updateErrorStatus([error.uuid], error.status);
        await resetAdminBadge();
      } catch (err) {
        actions.showErrorSnackbar(
          'Error updating error status. Please try again.',
          err as Error,
          'updateErrorStatus failed'
        );
      }
    };

    return {
      formatTimestamp,
      updateStatus,
      statusItems,
    };
  },
});
